import React from 'react';
import topicPolicyCheck, { TopicPolicyAction } from './topicPolicyCheck';
import type { AllTopicsTreeListTopic } from './useAllTopics';
import useAppSelector from '../app/redux/useAppSelector';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import Tooltip from '../components/Tooltip';
import { UserType } from '../graphql/generated/graphql';

interface ContentMapNewTopicButtonProps {
  topic?: AllTopicsTreeListTopic;
  size?: ButtonProps['size'];
  isPermittedToCreatePublicSubtopic: boolean;
  onCreateTopic: (reorganizeMode: boolean) => void;
}

const ContentMapNewTopicButton = ({
  topic,
  size = 'small',
  isPermittedToCreatePublicSubtopic,
  onCreateTopic,
}: ContentMapNewTopicButtonProps) => {
  const createNewNoun = topic ? 'subtopic' : 'topic';
  const currentUser = useAppSelector((state) => state.session.user);

  let disabledReason = null;

  const canReorganize =
    currentUser.type === UserType.Admin ||
    (!!topic &&
      topicPolicyCheck(TopicPolicyAction.ReorganizeTopic, topic, currentUser));

  if (topic?.privacy === 'PUBLIC' && !isPermittedToCreatePublicSubtopic) {
    disabledReason = 'Only admins can\ncreate subtopics of\na public topic';
  } else if (
    !canReorganize &&
    topic &&
    !topicPolicyCheck(TopicPolicyAction.AddSubtopic, topic, currentUser)
  ) {
    disabledReason = `You do not\nhave permission to\ncreate a ${createNewNoun}`;
  }

  const button = (
    <Button
      disabled={!!disabledReason}
      size={size}
      variant="secondary"
      onClick={() => {
        onCreateTopic(canReorganize);
      }}
    >
      Create a {createNewNoun}
    </Button>
  );

  return disabledReason ? (
    <Tooltip content={disabledReason} display="block">
      {button}
    </Tooltip>
  ) : (
    button
  );
};

export default ContentMapNewTopicButton;
